module.exports = __webpack_public_path__ + "img/599.07bf2d40.png";